import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import Sidebar from 'Shared/components/sidebar';
import { UserEditStatus } from '../user-administration-utils';
import UserEditMainTab from './tabs/user-edit-main-tab';
import BankIdTab from './tabs/bankid-tab';
import ChangePasswordTab from './tabs/change-password-tab';
import SelectDefaultOrgTab from './tabs/select-default-org-tab';
import AddOrganisationTab from './tabs/add-organisation-tab';
import styles from './user-edit-view.css';


export const TabOptions = {
  BANKID: 'bankid',
  CHANGE_PASS: 'changePass',
  DEFAULT_ORG: 'defaultOrg',
  ADD_ORG: 'addOrg',
  MAIN_TAB: 'mainTab',
};


const UserEditView = ({
  selectedUser,
  organisation,
  status,
  onHide,
  tab,
}) => {
  const [selectedTab, setSelectedTab] = useState(tab);
  const sidebarRef = useRef();

  useEffect(() => {
    if (sidebarRef && sidebarRef.current) {
      sidebarRef.current.scrollTop = 0;
    }
  }, [selectedTab]);

  useEffect(() => {
    setSelectedTab(tab);
  }, [tab]);

  const handleHide = (action) => {
    setSelectedTab(TabOptions.MAIN_TAB);
    onHide(action);
  };

  const handleDisplayTab = (option) => setSelectedTab(option);

  const handleShowMainTab = () => setSelectedTab(TabOptions.MAIN_TAB);

  const showSidebar = (status !== UserEditStatus.NONE);
  const mainTabStatus = (selectedTab === TabOptions.MAIN_TAB ? status : UserEditStatus.NONE);

  return (
    <Sidebar
      ref={sidebarRef}
      show={showSidebar}
      onClickOutside={handleHide}
      className={styles.container}
    >
      <UserEditMainTab
        display={selectedTab === TabOptions.MAIN_TAB}
        status={mainTabStatus}
        onHide={handleHide}
        selectedUser={selectedUser}
        organisation={organisation}
        tabOptions={TabOptions}
        displayTab={handleDisplayTab}
      />
      {(status === UserEditStatus.EDIT_SELF) && (
        <>
          <BankIdTab
            display={selectedTab === TabOptions.BANKID}
            onHide={handleShowMainTab}
            closeSidePanel={handleHide}
          />
          <ChangePasswordTab
            display={selectedTab === TabOptions.CHANGE_PASS}
            onHide={handleShowMainTab}
          />
          <SelectDefaultOrgTab
            display={selectedTab === TabOptions.DEFAULT_ORG}
            onHide={handleShowMainTab}
          />
          <AddOrganisationTab
            display={selectedTab === TabOptions.ADD_ORG}
            onHide={handleShowMainTab}
          />
        </>
      )}
    </Sidebar>
  );
};

UserEditView.defaultProps = {
  tab: TabOptions.MAIN_TAB,
};

UserEditView.propTypes = {
  selectedUser: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    socialSecurityNumber: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.number,
  }),
  organisation: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    organisationNumber: PropTypes.string,
  }),
  status: PropTypes.oneOf(Object.values(UserEditStatus)).isRequired,
  onHide: PropTypes.func.isRequired,
  tab: PropTypes.oneOf(Object.values(TabOptions)),
};

export default makeComponentTrashable(UserEditView);
